import { Injectable } from '@angular/core';
import { ResponsavelService } from '../shared/services/responsaveis.service';
import { FotoService } from './foto.service';

/**
 * Serviço centralizado para limpeza de caches da aplicação.
 *
 * @description
 * Este serviço é responsável por limpar todos os caches de dados da aplicação,
 * garantindo que não haja vazamento de informações entre sessões de diferentes usuários.
 * Deve ser chamado durante o processo de logout.
 *
 * @example
 * ```typescript
 * // No serviço de autenticação
 * logout() {
 *   this.cacheCleanerService.clearAllCaches();
 *   // ... resto do logout
 * }
 * ```
 */
@Injectable({
    providedIn: 'root',
})
export class CacheCleanerService {
    constructor(private responsavelService: ResponsavelService, private fotoService: FotoService) {}

    /**
     * Limpa todos os caches da aplicação.
     *
     * @description
     * Este método deve ser chamado durante o logout para garantir que
     * dados do usuário anterior não permaneçam em cache quando um novo
     * usuário fizer login.
     *
     * @remarks
     * - Limpa o cache de responsáveis
     * - Limpa o cache de fotos
     * - Adicione novos serviços com cache aqui conforme necessário
     *
     * @returns void
     */
    clearAllCaches(): void {
        // Limpa cache de responsáveis
        this.responsavelService.clearCache();

        // Limpa cache de fotos (notifica observadores)
        this.fotoService._fotoExcluida.next();

        console.log('[CacheCleanerService] Todos os caches foram limpos.');
    }
}
